import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../config/firebase';
import '../../styles/gallerySection.css';

const GallerySection = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const imagesRef = collection(db, 'gallery');
      const q = query(imagesRef, orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      const imagesData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setImages(imagesData);
    } catch (error) {
      console.error('Error fetching gallery images:', error);
    } finally {
      setLoading(false);
    }
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return (
      <section className="section gallery-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">📸 Our Gallery</h2>
            <p className="section-subtitle">Moments captured with our community</p>
          </div>
          <div className="gallery-loading">Loading gallery...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="section gallery-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">📸 Our Gallery</h2>
          <p className="section-subtitle">Moments captured with our community</p>
        </div>

        {images.length === 0 ? (
          <div className="coming-soon">
            <h3>COMING SOON</h3>
            <p>Our gallery is being prepared. Check back soon for amazing moments!</p>
          </div>
        ) : (
          <div className="gallery-grid">
            {images.map((image) => (
              <div 
                key={image.id} 
                className="gallery-item"
                onClick={() => openLightbox(image)}
              >
                <img 
                  src={image.url} 
                  alt={image.title || 'Gallery image'} 
                  className="gallery-image"
                />
                {image.title && (
                  <div className="gallery-overlay">
                    <h4 className="gallery-title">{image.title}</h4>
                    {image.description && (
                      <p className="gallery-description">{image.description}</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Lightbox Modal */}
        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="lightbox-close" onClick={closeLightbox}>
                &times;
              </button>
              <img 
                src={selectedImage.url} 
                alt={selectedImage.title || 'Gallery image'} 
                className="lightbox-image"
              />
              {selectedImage.title && (
                <div className="lightbox-info">
                  <h3>{selectedImage.title}</h3>
                  {selectedImage.description && <p>{selectedImage.description}</p>}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default GallerySection;
